import "./card.scss";

function Card(props) {
  const {
    icon = null,
    title,
    content,
    Type,
    children,
    bgPrimary = false,
  } = props;

  return (
    <div
      className={`cif__card-wrapper w-100 card__background-gradient ${
        bgPrimary ? "card__background_solid_primary" : ""
      }`}
    >
      {icon ? (
        <div className="cif__card-icon-wrapper">
          <div className="cif__card-icon">
            <img src={icon} alt="" />
          </div>
        </div>
      ) : null}
      <div className="cif__card-content-wrapper">{children}</div>
    </div>
  );
}

export default Card;
